<template>
    <div class="Realisations"
        @mouseenter="state.isHovering = true"  
        @mouseleave="state.isHovering = false">
        <ScrollBar />
        <!-- <ScrollForcer @onScrollForced="onScrollForced" :disable="state.isTweening"> -->
            <CustomScroll ref="scrollForcer" class="CustomScroll">
                <div class="CustomScroll-content Realisations-content" :multiply-wheel="1">
                    <ul v-if="!!realisations && !!description">
                        <li class="Realisations-li Realisations-name">{{ director.data.name[0].text }}</li>
                        <li v-for="(realisation,index) in realisations" class="Realisations-li Realisations-video" :key="index">
                            <VideoPlayer :url="realisation.video.url" :poster="realisation.image_preview.url">
                                <PlayerPlaceholder 
                                    :client="realisation.client[0].text"
                                    :title="realisation.title[0].text"
                                    :video="realisation.video_preview.url"
                                    :mobile-image="realisation.image_preview.mobile.url"
                                    :desktop-image="realisation.image_preview.url"></PlayerPlaceholder>
                            </VideoPlayer>
                        </li>
                        <li class="Realisations-li Realisations-desc">{{ description.text }}</li>
                    </ul>
                    <ul v-else>
                        <li class="Realisations-li">Contenu à venir.</li>
                    </ul>
                </div>
            </CustomScroll>
        <!-- </ScrollForcer> -->
    </div>
</template>

<script>

import Store from '@/stores/store.js'
import Data from '@/data/data.js'

import CustomScroll from '@/components/CustomScroll.vue'
import ScrollBar from '@/components/ScrollBar.vue'
// import ScrollForcer from '@/components/ScrollForcer.vue'
import VideoPlayer from '@/components/VideoPlayer.vue'
import PlayerPlaceholder from '@/components/PlayerPlaceholder.vue'

export default {
    name: 'Realisations',
    props: {
        msg: String
    },
    components:{
        CustomScroll,
        VideoPlayer,
        PlayerPlaceholder,
        ScrollBar,
        // ScrollForcer
    },
    data(){
        return{
            state: Store.state
        }
    },
    created() {
        this.director = Store.state.currentDirector;
        
        this.realisations = this.director.data.realisations;
        this.description = this.director.data.description[0];
    },
    beforeRouteLeave (to, from, next) {
        Store.state.currentDirector = null;
        next();
    },
    beforeRouteUpdate: (to, from, next) => {
        Data.getDirectorBySlug(to.params.slug).then((director) => {
            Store.state.currentDirector = director;
            next();
        });
    },
    methods: {
        onScrollForced(direction){
            const indexOfPos = Data.getDirectors().indexOf( this.director )

            if( direction === 'bottom'){
                if(  indexOfPos !== Data.getDirectors().length-1 ){
                    this.$router.push({ path: '/directors/' + Data.getDirectors()[indexOfPos+1].slugs[0] });
                }
            }else{
                if(  indexOfPos !== 0 ){
                    this.$router.push({ path: '/directors/' + Data.getDirectors()[indexOfPos-1].slugs[0] });
                }
            }
        },

        enterAnimMobile(done){
            TweenMax.from(this.$el, 1, {height: 0, ease: Power2.easeInOut, onComplete: done });
        },

        leaveAnimMobile(done){
            TweenMax.to(this.$el, 1, { height: 0, ease: Power2.easeInOut, onComplete: done });
        },

        onResize(){
            this.contentHeight = this.$refs.scrollForcer.$el.clientHeight;
            TweenMax.to(this.$el, 0.6, {height: this.contentHeight, ease: Power2.easeOut });
        },
        
 
        enterAnim(done){
            setTimeout(() => {
                done();
            }, 1500);
        },

        leaveAnim(done){
            setTimeout(() => {
                done();
            }, 700);
        },
    },
}
</script>


<style lang="scss">
    .Realisations{
        position: fixed;
        right: 0;
        top: 0;
        height: 100%;
        width: 50%;
        padding: 0 70px 0 0;
        opacity: 1;
        transition: opacity .6s linear;

        z-index: zindex(realisations);

        &-video{
            width: 100%;
            @include aspect-ratio(16,9);
            background-color: color(black);
            transform: translateZ(0);
        }
        
        &-li{
            & + & {
                margin-top: 20px;
            }
        }

        &-content{
            padding: 70px 0;
        }

        .CustomScroll{
            height: 100%;
            overflow: hidden;
            
            &-content{
                padding-bottom: 4vw;
                @include respond-to(md){
                    padding-top: 10px;
                }
            }
        }

        &-desc{
            &.Realisations-li{
                margin-top: 40px;
                @include respond-to(md){
                    margin-top: 15px;
                }
            }
            text-transform: none;
            font-variation-settings: "wght" 300, "wdth" 50;
            line-height: 1.9;
            font-size: rem(18px);
            color: #BBB;
            
            @include respond-to(sm){
                font-size: 16px;
                line-height: 1.4;
            }
        }

        &-name {
            font-variation-settings: "wght" 900, "wdth" 1;
            font-size: rem(60px);
            margin-top: 40px;
            text-transform: uppercase;
            display: none;
            @include respond-to(md){
                display: inherit;
            }
        }
    }


    .Realisations.v-enter-active{
        .Realisations-li{
            @for $i from 1 through 4 {
                transition: transform .8s $ease-out-quint;
                &:nth-child(#{$i}){
                    transition-delay: (0.1s * $i);
                }
                .PlayerPlaceholder-image{
                    transform-origin: top left;
                    transition: transform .8s $ease-out-quint;
                    transition-delay: (0.1s * $i);
                }
            }
        }
    }
    .Realisations.v-leave-active{
        .Realisations-li{
            @for $i from 1 through 4 {
                transition: transform .4s $ease-out-quint;
                &:nth-child(#{$i}){
                    transition-delay: (0.025s * $i);
                }
                .PlayerPlaceholder-image{
                    transform-origin: top left;
                    transition: transform .4s $ease-out-quint;
                    transition-delay: (0.025s * $i);
                }
            }
        }
    }
    
    .Realisations.v-enter, .Realisations.v-leave-to {
        opacity: 0.99;
        .Realisations-li{
            transform: translateX(100%) translateZ(0);
        }
        .PlayerPlaceholder-image{
            transform: scaleX(2);
        }
    }


    .isTouch {
        .Realisations {
            position: absolute;
            width: 100%;
            height: calc(100% - 65px);
            padding: 0 0; 
            top: 65px;
            overflow: hidden;
        
            &-li{
                & + & {
                    margin-top: 13px;
                }
            }

            &-content{
                    padding: 0;
            }

            &-name {
                padding: 0 20px;
            }
            

            .CustomScroll{
                overflow-y: auto;
                overflow-x: hidden;

                &-content{
                    padding-top: 10px;
                }
            }

            &-desc{
                padding: 0px 20px 10px 20px;
                &.Realisations-li{
                    margin-top: 15px;
                }
                font-size: 16px;
                line-height: 1.4;
            }

            &-name {
                display: inherit;
            }
        }
    }
</style>
